import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { OtherFinancialFlowFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/other-financial-flow/other-financial-flow-find-many-query.dto';
import type { OtherFinancialFlowPageInterface } from '@zaoblako/shared/modules/catalog/dtos/other-financial-flow/other-financial-flow-page.dto';

import { Injectable } from '@angular/core';
import { concatMap, type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtherFinancialFlowService extends BaseService {
  protected baseUrl = '/basis/catalog/other-financial-flow';

  public get dropdownDescriptorApi(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }

  public synchronize1c(): Observable<null> {
    return this.http.get<null>(`${this.baseUrl}/synchronize-1c`);
  }

  public getDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getItems(
    params?: OtherFinancialFlowFindManyQueryInterface,
    descriptor?: ReportDescriptorInterface
  ): Observable<OtherFinancialFlowPageInterface> {
    if (descriptor?.subroutes?.items) {
      return this.http.get<OtherFinancialFlowPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
        params: params
          ? this.objectToHttpParams(params)
          : {}
      });
    } else {
      return this
        .getDescriptor()
        .pipe(concatMap((descriptor) => this.http.get<OtherFinancialFlowPageInterface>(`${this.baseUrl}${descriptor.subroutes.items}`, {
          params: params
            ? this.objectToHttpParams(params)
            : {}
        })))
    }
  }
}
